import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "success-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "pre-line" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onCancel: _ctx.cancel }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "icon",
          src: _ctx.getSuccessImg(),
          alt: "success"
        }, null, 8, _hoisted_2),
        (_ctx.optionalImage)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "optional-image",
              src: _ctx.optionalImage,
              alt: "optional"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1),
        _createElementVNode("img", {
          class: "close-icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          src: _ctx.closeIcon,
          alt: "close"
        }, null, 8, _hoisted_5)
      ])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}